import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Image from 'next/image';
import { ClipboardIcon } from '@heroicons/react/24/outline';

export default function PaymentCard( { paymentName, accountName, accountNumber, image } ) {
  const [ copied, setCopied ] = useState( false );

  const copyAccountNo = () => {
    navigator.clipboard.writeText( accountNumber );
    setCopied( true );
  };

  return (
    <div className="cursor-pointer bg-gray-100 p-4 shadow-md rounded-xl">
      <h4 className="text-xl font-bold text-center text-gray-900">{paymentName}</h4>
      <div className="flex flex-col">
        <div className="p-2 text-base font-semibold">
          <p className="text-gray-800">{accountName}</p>
          <p className="flex justify-between text-gray-800">
            <span>
              {accountNumber}
            </span>
            <button type="button" className="flex items-center text-gray-500 text-xs font-light select-none" onClick={ copyAccountNo }>
              <ClipboardIcon className="w-5 h-5" />
              {copied && 'Copied'}
            </button>
          </p>

        </div>
        {image && (
          <div className="unset-img relative">
            <Image
              src={ image }
              layout="fill"
              objectFit="contain"
              className="custom-img"
              placeholder="blur"
              blurDataURL="images/placeholder.png"
              alt={ paymentName }
            />
          </div>
        )}
      </div>
    </div>
  );
}

PaymentCard.propTypes = {
  paymentName: PropTypes.string.isRequired,
  accountName: PropTypes.string.isRequired,
  accountNumber: PropTypes.string.isRequired,
  image: PropTypes.string,
};
